export default __webpack_public_path__ + "static/media/ticket.06b53746.svg";